import '../assets/fonts/fonts.css';

interface FooterProps {
  className?: string;
}

export default function Footer({ className }: FooterProps) {
  return (
    <footer className={`${className || ''} bg-[#000]`}>
      <div className="container mx-auto">
        <div className="text-center text-[1vw]">
          <br />
          <p>© 2025 天籁瓷鉴 Tianlai.China. All rights reserved.</p>
          <p>A digital humanities project dedicated to Chinese porcelain art and culture.</p>
          {/* <p>Power by Liwen Zhang.</p> */}
          <br />
        </div>
      </div>
    </footer>
  )
}